import interpolate from 'color-interpolate'
import gsap from 'gsap'
import store from '@/store'
import { playUnlock } from '@/lib/sound.js'
import { Projector } from '@/lib/projection.js'
import { buildArcPath, rotateVector } from '@/lib/vector.js'
import { Line, CubicBezier } from '@/lib/elements.js'

let buttons_to_move, orig_pos
let block_progress_change

function sliderotate(event) {
  store.commit('SET_BLOCK_CLICKS', [1, 2, 3, 4, 5, 6, 7, 8, 9])

  block_progress_change = false

  console.log(store.getters.button_vals)
  const colourmap = interpolate(['#cdf4dd', '#468B18'])
  buttons_to_move = ['button-7']

  const projector = new Projector()

  orig_pos = [
    'button-7',
    'button-5',
    'button-3',
    'button-1',
    'button-9',
  ].reduce((s, x) => {
    s[x] = document.getElementById(x).getBoundingClientRect()
    return s
  }, {})

  const x_step = orig_pos['button-5'].x - orig_pos['button-7'].x
  const y_step = orig_pos['button-5'].y - orig_pos['button-7'].y

  const l1 = new Line({
    id: 'l1',
    p1: { x: orig_pos['button-7'].x, y: orig_pos['button-7'].y },
    p2: { x: orig_pos['button-5'].x, y: orig_pos['button-5'].y },
    enter: () => {
      buttons_to_move = ['button-7']
    },
    move: ({ t }) => {
      if (!block_progress_change) {
        store.commit(
          'SET_UNLOCK_PROGRESS',
          (t * l1.length * 100) / total_length
        )
      }
    },
  })

  const colourChange1 = new Line({
    id: 'colourChange1',
    p1: { x: orig_pos['button-5'].x, y: orig_pos['button-5'].y },
    p2: {
      x: orig_pos['button-5'].x + x_step * 0.3,
      y: orig_pos['button-5'].y + y_step * 0.3,
    },
    hiddenX: true,
    hiddenY: true,
    enter: () => {
      buttons_to_move = ['button-5', 'button-7']
    },
    move: ({ t }) => {
      const colour = colourmap(t / 2)
      buttons_to_move.forEach((b) => {
        updateButtonColour(b, colour)
      })
    },
  })

  const l2 = new Line({
    id: 'l2',
    p1: { x: orig_pos['button-5'].x, y: orig_pos['button-5'].y },
    p2: { x: orig_pos['button-3'].x, y: orig_pos['button-3'].y },
    enter: () => {
      updateButtonColour('button-3', colourmap(0))
      buttons_to_move = ['button-5', 'button-7']
    },
    move: ({ t }) => {
      if (!block_progress_change) {
        const current_progress = (l1.length * 100) / total_length
        store.commit(
          'SET_UNLOCK_PROGRESS',
          current_progress + (t * l2.length * 100) / total_length
        )
      }
    },
  })

  const colourChange2 = new Line({
    id: 'colourChange2',
    p1: { x: orig_pos['button-3'].x, y: orig_pos['button-3'].y },
    p2: {
      x: orig_pos['button-3'].x + x_step * 0.3,
      y: orig_pos['button-3'].y + y_step * 0.3,
    },
    hiddenX: true,
    hiddenY: true,
    enter: () => {
      buttons_to_move = ['button-5', 'button-7', 'button-3']
    },
    move: ({ t }) => {
      const colour = colourmap(t / 2 + 0.5)
      buttons_to_move.forEach((b) => {
        updateButtonColour(b, colour)
      })
    },
  })

  const origin = orig_pos['button-5']
  const r = Math.sqrt(x_step ** 2 + y_step ** 2)
  const theta0 = Math.atan(y_step / x_step)

  const arc1 = new CubicBezier({
    id: 'arc1',
    ...buildArcPath(r, origin.x, origin.y, theta0, theta0 - Math.PI / 2),
    enter: () => {
      buttons_to_move = [
        'button-5',
        'button-7',
        'button-3',
        'button-1',
        'button-9',
      ]
    },
    exit: (proj, { t_end }) => {
      if (t_end == 0) {
        resetButtonStyle('button-1')
        resetButtonStyle('button-9')
      }
    },
    move: ({ t }) => {
      if (!block_progress_change) {
        const current_progress = ((l1.length + l2.length) * 100) / total_length
        store.commit(
          'SET_UNLOCK_PROGRESS',
          current_progress + (t * arc1.length * 100) / total_length
        )
      }
    },
  })

  const arc2 = new CubicBezier({
    id: 'arc2',
    ...buildArcPath(
      r,
      orig_pos['button-5'].x,
      orig_pos['button-5'].y,
      theta0 - Math.PI / 2,
      theta0 - Math.PI
    ),
    exit: ({ t, current_element }) => {
      if (t == 1 && current_element.id == 'arc2') {
        console.log('triggered')
        triggered()
      }
    },
    move: ({ t }) => {
      if (!block_progress_change) {
        const current_progress =
          ((l1.length + l2.length + arc1.length) * 100) / total_length
        store.commit(
          'SET_UNLOCK_PROGRESS',
          current_progress + (t * arc2.length * 100) / total_length
        )
      }
    },
  })

  l1.addPostConnection(colourChange1)
  colourChange1.addPrevConnection(l1)
  colourChange1.addPostConnection(l2)
  l2.addPrevConnection(colourChange1)
  l2.addPostConnection(colourChange2)
  colourChange2.addPrevConnection(l2)
  colourChange2.addPostConnection(arc1)
  arc1.addPrevConnection(colourChange2)
  arc1.addPostConnection(arc2)
  arc2.addPrevConnection(arc1)

  projector.elements = [l1, colourChange1, l2, colourChange2, arc1, arc2]
  projector.setCurrentElement(l1)
  projector.t = 0

  const total_length = projector.elements
    .filter((e) => !(e.hiddenX && e.hiddenY))
    .map((e) => e.length)
    .reduce((s, x) => {
      return x + s
    }, 0)

  let clientX =
    event.type == 'touchstart' ? event.changedTouches[0].clientX : event.clientX
  let clientY =
    event.type == 'touchstart' ? event.changedTouches[0].clientY : event.clientY

  const move_listener = function (e) {
    let newClientX =
      e.type == 'touchmove' ? e.changedTouches[0].clientX : e.clientX
    let newClientY =
      e.type == 'touchmove' ? e.changedTouches[0].clientY : e.clientY

    const movement = { x: newClientX - clientX, y: newClientY - clientY }

    const vals = projector.getMove(movement)
    projector.moveTo(vals)
    const pos = projector.getPoint()

    moveButtons(pos)

    clientX = newClientX
    clientY = newClientY
  }

  window.addEventListener('mousemove', move_listener)
  window.addEventListener('touchmove', move_listener)

  const mouseup_listener = function () {
    console.log('mouseup')
    window.removeEventListener('mousemove', move_listener)
    window.removeEventListener('mouseup', mouseup_listener)
    window.removeEventListener('touchmove', move_listener)
    window.removeEventListener('touchend', mouseup_listener)

    block_progress_change = true
    store.commit('SET_UNLOCK_PROGRESS', 0)

    reverseBack(projector).then(() => {
      resetButtonStyle('button-7')
      resetButtonStyle('button-5')
      resetButtonStyle('button-3')
      resetButtonStyle('button-1')
      resetButtonStyle('button-9')
      store.commit('SET_BLOCK_CLICKS', [])
    })
  }

  const triggered = function () {
    console.log('triggered function')
    let unlocking = !store.getters.isActionUnlocked('sliderotate')

    window.removeEventListener('mousemove', move_listener)
    window.removeEventListener('mouseup', mouseup_listener)
    window.removeEventListener('touchmove', move_listener)
    window.removeEventListener('touchend', mouseup_listener)

    setTimeout(() => {
      store.commit('SET_UNLOCK_PROGRESS', 0)
    }, 200)

    if (unlocking) {
      playUnlock()
    } else {
      store.commit(
        'SET_MOVE_NAME_ANIMATE',
        store.getters.actions['sliderotate']
      )
    }

    gsap.fromTo(
      '#button-7',
      {
        x: 0,
        y: 0,
      },
      {
        x: x_step * 2,
        y: y_step * 2,
        color: '#cdf4dd',
        borderColor: '#cdf4dd',
        duration: 0.5,
        delay: unlocking ? 1 : 0,
      }
    )
    gsap.fromTo(
      '#button-5',
      {
        x: -x_step,
        y: -y_step,
      },

      {
        x: 0,
        y: 0,
        color: '#cdf4dd',
        borderColor: '#cdf4dd',
        duration: 0.5,
        delay: unlocking ? 1 : 0,
      }
    )
    gsap.to('#button-3', {
      color: '#cdf4dd',
      borderColor: '#cdf4dd',
      duration: 0.5,
      delay: unlocking ? 1 : 0,
      onComplete: () => {
        let new_vals = [...store.getters.button_vals]
        const old_three = new_vals[2]
        new_vals[2] = new_vals[6]
        new_vals[6] = old_three
        const old_one = new_vals[0]
        new_vals[0] = new_vals[8]
        new_vals[8] = old_one
        store.commit('SET_BUTTON_VALS', new_vals)
        resetButtonStyle('button-7')
        resetButtonStyle('button-5')
        resetButtonStyle('button-3')
        resetButtonStyle('button-1')
        resetButtonStyle('button-9')
        if (unlocking) {
          store.dispatch('unlock_action', 'sliderotate')
          setTimeout(() => {
            store.commit('SET_SHOW_UNLOCK_DIALOG', true)
          }, 500)
        } else {
          store.commit('SET_BLOCK_CLICKS', [])
        }
      },
    })
  }
  window.addEventListener('mouseup', mouseup_listener)
  window.addEventListener('touchend', mouseup_listener)
}

function updateButtonPosition(button_id, x, y, orig_pos) {
  const button = document.getElementById(button_id)
  gsap.set(button, {
    x: x - orig_pos.x,
    y: y - orig_pos.y,
  })
  //button.style.transform = `translate(${x - orig_pos.x}px, ${y - orig_pos.y}px)`
}

function updateButtonColour(button_id, colour) {
  const button = document.getElementById(button_id)
  gsap.set(button, {
    color: colour,
    borderColor: colour,
  })
  //button.style.color = colour
  //button.style.borderColor = colour
}

function resetButtonStyle(button_id) {
  const button = document.getElementById(button_id)
  gsap.set(button, { clearProps: 'all' })
}

function moveButtons(pos) {
  const origin = orig_pos['button-5']
  const rotations = {
    'button-1': -Math.PI / 2,
    'button-9': (-3 * Math.PI) / 2,
  }

  buttons_to_move.forEach((b) => {
    let newPos = pos
    if (b in rotations) {
      newPos = rotateVector(newPos, rotations[b], origin)
    }
    updateButtonPosition(b, newPos.x, newPos.y, orig_pos[b])
  })
}

function reverseBack(proj) {
  return new Promise((resolve) => {
    let i = 0
    const animBack = () => {
      gsap.to(['#button-7', '#button-5', '#button-3'], {
        x: 0,
        y: 0,
        color: '#cdf4dd',
        borderColor: '#cdf4dd',
        duration: 0.5,
        onComplete: resolve,
      })
    }

    if (['arc1', 'arc2'].includes(proj.current_element.id)) {
      let interval = setInterval(() => {
        proj.nudgeT(-0.075)
        if (i > 100 || proj.current_element.id == 'colourChange2') {
          clearInterval(interval)
          animBack()
          //resolve()
          return
        }
        const pos = proj.getPoint()
        moveButtons(pos)
        i += 1
      }, 10)
    } else {
      animBack()
    }
  })
}

export default sliderotate
